export const LOGOS = {
  // Official AzoApp horizontal wordmark — blue for light mode, white for dark mode
  light: "https://customer-assets-v7afamib.emergentagent.net/job_mens-fashion-wear/artifacts/4yr428qw_gnfdghfu.png",
  dark: "https://customer-assets-v7afamib.emergentagent.net/job_mens-fashion-wear/artifacts/0jea2kq7_dfgdfe.png",
};

export const SITE = {
  name: "AzoApp",
  tagline: "Service at Your Doorstep",
  url: "https://azoapp.in",
  logo: "https://customer-assets-v7afamib.emergentagent.net/job_mens-fashion-wear/artifacts/op0kpw3q_1.png",
};

export const APP_LINKS = {
  customer: "https://play.google.com/store/apps/details?id=app.azoapp.homeservice",
  partner: "https://play.google.com/store/apps/details?id=app.azoapp.partner",
};

export const CONTACT = {
  phone: "7463008300",
  phoneDisplay: "+91 74630 08300",
  whatsapp: "917463008300",
  email: "support@azoapp.in",
  hours: "09:00 AM – 06:00 PM IST",
  address: "Tajpur Road, Gali Number 1, Kashipur, Samastipur, Bihar 848101",
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/azoappservices/",
  youtube: "https://www.youtube.com/@AzoApp01",
  facebook: "https://www.facebook.com/profile.php?id=61589507292732",
};

const PUB = process.env.PUBLIC_URL || "";

// Hero & partner: technicians wearing AzoApp-branded uniforms (logo added to shirts)
export const HERO_IMG = PUB + "/hero-azoapp.webp";
export const PARTNER_IMG = PUB + "/partner-azoapp.webp";

export const SERVICES = [
  {
    id: "electrician", name: "Electrician", hindi: "इलेक्ट्रिशियन", emoji: "⚡", icon: "Zap",
    badge: "15-min urgent", accent: "#FF8F00", from: "₹149", rating: "4.9",
    desc: "Wiring, switchboard, fan & appliance fitting, aur fault repair.",
    img: PUB + "/svc-electrician.webp",
    tags: ["Wiring", "Switchboard", "Fan Fitting"],
  },
  {
    id: "plumber", name: "Plumber", hindi: "प्लंबर", emoji: "💧", icon: "Droplets",
    badge: "Leakage master", accent: "#0091EA", from: "₹149", rating: "4.8",
    desc: "Pipe leakage, tap & basin fitting, water tank aur bathroom work.",
    img: PUB + "/svc-plumber.webp",
    tags: ["Leakage", "Tap Fitting", "Bathroom"],
  },
  {
    id: "carpenter", name: "Carpenter", hindi: "कारपेंटर", emoji: "🔨", icon: "Hammer",
    badge: "Furniture pro", accent: "#8D6E63", from: "₹199", rating: "4.8",
    desc: "Furniture repair, door & lock, bed, cabinet aur modular work.",
    img: PUB + "/svc-carpenter.webp",
    tags: ["Furniture", "Door Lock", "Cabinet"],
  },
  {
    id: "ac-repair", name: "AC Repair & Service", hindi: "एसी रिपेयर", emoji: "❄️", icon: "Snowflake",
    badge: "Cooling expert", accent: "#00B8D4", from: "₹399", rating: "4.9",
    desc: "Foam-jet service, gas refill, PCB aur installation — sabhi brands ke liye.",
    img: PUB + "/svc-ac-repair.webp",
    tags: ["Deep Service", "Gas Refill", "Install"],
  },
  {
    id: "cleaning", name: "Deep Home Cleaning", hindi: "सफाई सेवा", emoji: "🧹", icon: "Sparkles",
    badge: "Full home sparkle", accent: "#00A152", from: "₹499", rating: "4.8",
    desc: "Bathroom, kitchen, sofa aur full-home deep cleaning services.",
    img: PUB + "/svc-cleaning.webp",
    tags: ["Kitchen", "Bathroom", "Sofa"],
  },
  {
    id: "barber", name: "Barber & Grooming", hindi: "नाई व ग्रूमिंग", emoji: "💈", icon: "Scissors",
    badge: "Salon at home", accent: "#7C4DFF", from: "₹199", rating: "4.9",
    desc: "Haircut, beard styling, facial aur relaxing head massage.",
    img: PUB + "/svc-barber.webp",
    tags: ["Haircut", "Beard", "Facial"],
  },
  {
    id: "beauty-makeup", name: "Beauty & Makeup", hindi: "ब्यूटी व मेकअप", emoji: "💄", icon: "Heart",
    badge: "Certified beauticians", accent: "#EC407A", from: "₹499", rating: "4.9",
    desc: "Waxing, facial, threading, pedicure aur bridal makeup — sab ghar par.",
    img: PUB + "/svc-beauty.webp",
    tags: ["Facial", "Waxing", "Bridal"],
  },
];

export const CITIES = [
  { name: "Patna", tag: "Capital Hub", pros: "250+" },
  { name: "Muzaffarpur", tag: "North Zone", pros: "180+" },
  { name: "Samastipur", tag: "Central Hub", pros: "120+" },
  { name: "Darbhanga", tag: "Mithila Region", pros: "150+" },
  { name: "Begusarai", tag: "Industrial Hub", pros: "110+" },
  { name: "Bhagalpur", tag: "Silk City", pros: "140+" },
  { name: "Gaya", tag: "South Zone", pros: "130+" },
  { name: "Purnea", tag: "Seemanchal", pros: "100+" },
];

export const STEPS = [
  { n: "01", title: "Download & Book", desc: "AzoApp download karo, apni city aur service choose karo — bas 30 second me booking done.", icon: "Smartphone" },
  { n: "02", title: "Expert Reaches You", desc: "Verified partner apne tools ke saath aapke ghar, sahi time par pahunch jaata hai.", icon: "MapPin" },
  { n: "03", title: "Kaam Complete", desc: "Payment ke baad verified expert aapke doorstep par quality kaam complete karta hai.", icon: "BadgeCheck" },
];

export const STATS = [
  { value: "10,000+", label: "Services delivered", icon: "CheckCircle2" },
  { value: "300+", label: "Verified partners", icon: "ShieldCheck" },
  { value: "8", label: "Bihar cities live", icon: "MapPin" },
  { value: "4.8★", label: "Average rating", icon: "Star" },
];

export const TESTIMONIALS = [
  {
    name: "Rahul Kumar",
    city: "Patna",
    service: "Electrician",
    rating: 5,
    text: "Bihar me pehli baar aisa app dekha. 25 minute me electrician ghar aaya aur switchboard theek kar diya. Bilkul professional aur reasonable rate.",
  },
  {
    name: "Priya Singh",
    city: "Muzaffarpur",
    service: "Deep Cleaning",
    rating: 5,
    text: "Diwali se pehle full home deep cleaning karwayi AzoApp se. Team time par aayi, kitchen aur bathroom chamak gaye. Highly recommended!",
  },
  {
    name: "Md. Imran",
    city: "Darbhanga",
    service: "AC Repair",
    rating: 5,
    text: "AC gas refill aur service dono same day ho gaya. Technician verified tha, ID card dikhaya. Payment fully secure aur transparent. Trust ban gaya.",
  },
  {
    name: "Sunita Devi",
    city: "Samastipur",
    service: "Beauty & Makeup",
    rating: 5,
    text: "Bridal makeup ghar par hi karwaya, beautician certified thi. Itni convenient service pehle kabhi nahi mili. Thank you AzoApp!",
  },
  {
    name: "Amit Raj",
    city: "Bhagalpur",
    service: "Plumber",
    rating: 5,
    text: "Bathroom leakage ka problem 1 hour me solve. Plumber ne pura kaam neatly kiya. Ab har service AzoApp se hi book karta hoon.",
  },
  {
    name: "Neha Gupta",
    city: "Gaya",
    service: "Carpenter",
    rating: 5,
    text: "Bed aur almirah repair karwaya. Carpenter skilled tha aur apne tools ke saath aaya. Pricing transparent thi, koi hidden charge nahi.",
  },
];

export const FAQS = [
  {
    q: "AzoApp par service kaise book karein?",
    a: "AzoApp Customer App ko Google Play se download karo, apni city aur service (Electrician, Plumber, Carpenter, AC Repair, Cleaning, Barber ya Beauty) choose karo aur 30 second me booking confirm karo. Verified professional aapke doorstep par pahunch jayega.",
  },
  {
    q: "AzoApp Bihar ke kin cities me available hai?",
    a: "AzoApp abhi Patna, Muzaffarpur, Samastipur, Darbhanga, Begusarai, Bhagalpur, Gaya aur Purnea me live hai. Naye cities jald add ho rahe hain.",
  },
  {
    q: "Kya AzoApp ke professionals verified hote hain?",
    a: "Haan. Har professional background-verified aur skill-tested hota hai. Sirf ID-verified partners hi aapke ghar aate hain, taaki aapko safe aur trusted home service mile.",
  },
  {
    q: "Payment kaise hota hai?",
    a: "AzoApp par transparent, upfront pricing hai. Aap booking ke time secure payment karte hain aur uske baad verified expert aapka kaam complete karta hai. Koi hidden charge nahi.",
  },
  {
    q: "AzoApp par konsi home services milti hain?",
    a: "AzoApp par Electrician, Plumber, Carpenter, AC Repair & Service, Deep Home Cleaning, Barber & Grooming aur Beauty & Makeup jaisi sabhi zaroori home services milti hain — seedhe aapke doorstep par.",
  },
  {
    q: "Main AzoApp par service partner kaise banun?",
    a: "AzoApp Partner App download karo, apna profile aur skill verify karwao aur apne area me bookings lena start karo. Flexible working hours ke saath acchi earning ka mauka.",
  },
];
